export function createUniqueFilename(
  filename: string,
  existingFilenames: string[]
): string {
  // Replace undesirable characters with underscore
  let cleanedFilename = filename.replace(/[/:*%?"<>|]/g, "_");

  const extIndex = cleanedFilename.lastIndexOf(".");
  const ext = filename.split(".").pop();
  const nameWithoutExt = cleanedFilename.substring(0, extIndex);

  if (!existingFilenames.find(fn => fn === cleanedFilename)) {
    // Filename is unique already, no need for further processing.
    return cleanedFilename;
  }

  let maxSuffixNumber = 0;

  const escapedNameWithoutExt = nameWithoutExt.replace(
    /[-[\]{}()*+?.,\\^$|#\s]/g,
    "\\$&"
  );
  const regexFilenameHasNumberSuffix = new RegExp(
    `${escapedNameWithoutExt} \\((\\d+)\\)\\.${ext}$`
  );

  let newFilename = cleanedFilename;

  // Check if any existing filenames match the pattern `{filename} (number).{ext}` and get max number.
  existingFilenames.forEach(efn => {
    const match = efn.match(regexFilenameHasNumberSuffix);
    if (match) {
      const numberFromFilename = Number.isFinite(parseInt(match[1]))
        ? parseInt(match[1])
        : 0;
      if (numberFromFilename > maxSuffixNumber) {
        maxSuffixNumber = numberFromFilename;
        // Get the filename text up to but excluding the final "({number})" part.
        const matchBeforeLastNumber = efn.match(/(.*?)\(\d+\)(?=\.\w+$)/);
        if (typeof matchBeforeLastNumber?.[1] === "string") {
          // Create new filename by incrementing the number part.
          newFilename = `${matchBeforeLastNumber[1].trimEnd()} (${maxSuffixNumber +
            1}).${ext}`;
        }
      }
    }
  });

  return maxSuffixNumber > 0 ? newFilename : `${nameWithoutExt} (1).${ext}`;
}
